module.exports = __webpack_public_path__ + "img/studying.a6c36887.svg";